<template>
    <div>
        <loading
            :active="loading"
            is-full-screen
            spinner="bar-fade-scale"
            color="#6495ED"
        />
        <div class="filter-container">
            <div class="left-content"></div>
            <div class="right-content">
                <b-button v-if="openAddTab" variant="light" @click="goBack">
                    <i class="icon icon-keyboard icon-rotate-180"></i>
                    {{ $t('modules.explanatory_note.back_to_list') }}
                </b-button>
                <template v-if="editAccess">
                    <b-button v-if="openAddTab" variant="success" @click="saveData">
                        {{ $t('modules.budget_execution_alteration.save') }}
                    </b-button>
                </template>
            </div>
        </div>

        <c-breadcrumbs :curYear="curYear" :curRegion="curRegion" :curAbp="curAbp" :curGu="curGu"
                       :isGkkp="isGkkp" :curGkkp="curGkkp" :curBudgetType="curBudgetType"
                       :curBudgetVariant="curBudgetVariant" :curPrg="curPrg"></c-breadcrumbs>

        <div class="inner-container">
            <b-tabs class="tabs-in-tabs">

                <b-tab :title="$t('modules.explanatory_note.basic_info')">
                    <div class="table-container exp-note-table">
                        <b-table-simple class="table-striped">
                            <b-thead>
                                <tr>
                                    <b-th rowspan="2">
                                        {{ $t('modules.budget_execution_alteration.name') }}
                                    </b-th>
                                    <b-th colspan="3" class="text-center">
                                        {{ $t('modules.bip.filter.filter_params.plan_period') }}
                                    </b-th>
                                </tr>
                                <tr>
                                    <template v-for="(year, index) in curYear.periods">
                                        <b-th class="text-center" width="26%" :key="index">{{
                                                year
                                            }} {{
                                                $t('modules.budget.staffing_table.file_storage.filter.year')
                                            }}
                                        </b-th>
                                    </template>
                                </tr>
                            </b-thead>
                            <b-tbody>
                                <tr v-for="(descItem, descItemIndex) of tabDataOne"
                                    :key="descItemIndex">
                                    <td class="bold">{{ getLocalizedName(descItem) }}</td>
                                    <template v-for="(year, index) in curYear.periods">
                                        <td :key="index">
                                            <div class="exp-textarea-style"
                                                 v-bind:class="[allowable(descItem.years[index]) ? descriptionNotEmpty : descriptionEmpty]"
                                                 style="text-align: justify">

                                                    <span class="enf-placeholder">
                                                        {{
                                                            getPlaceholderText(descItem.years[index])
                                                        }}
                                                    </span>
                                                <template v-if="isShortNote(descItem.years[index])">
                                                    {{ getLocalizedNote(descItem.years[index]) }}
                                                </template>
                                                <template v-else>
                                                    {{ shortNote(descItem.years[index]) }}...
                                                </template>

                                                <template
                                                    v-if="editAccess && descItem.years[index].isEditable">
                                                    <i class="tas-action icon icon-pencil-edit"
                                                       @click="editDescription(true,
                                                       descItem.years[index])"></i>
                                                </template>
                                                <template v-else>
                                                    <i class="tas-action icon icon-eye-open"
                                                       @click="editDescription(descItem.years[index].isEditable,
                                                                       descItem.years[index])"></i>
                                                </template>
                                            </div>
                                        </td>
                                    </template>
                                </tr>
                            </b-tbody>
                        </b-table-simple>
                    </div>
                </b-tab>

                <b-tab :title="$t('modules.explanatory_note.goals')">
                    <ExplanatoryNoteAddTable :curYear="curYear" :curAbp="curAbp" :curGu="curGu"
                                             :curGkkp="curGkkp" :isGkkp="isGkkp"
                                             :curRegion="curRegion" :curBudgetType="curBudgetType"
                                             :curBudgetVariant="curBudgetVariant"
                                             :curPrg="curPrg" :saveBtnPressed="saveBtnPressed"
                                             :editAccess="editAccess" :uniqueYears="uniqueYears"
                                             @needSaved="needSaved" :needSave="needSave"
                                             @indicatorsArr="indicatorsArr"/>
                </b-tab>

                <b-tab
                    :title="$t('modules.budget_execution_monitoring.input_forms.filter.expenses')">
                    <div class="table-container exp-note-table">
                        <b-table-simple class="table-striped">
                            <b-thead>
                                <tr>
                                    <b-th rowspan="2">
                                        {{ $t('modules.budget_execution_alteration.name') }}
                                    </b-th>
                                    <b-th colspan="3" class="text-center">
                                        {{ $t('modules.bip.filter.filter_params.plan_period') }}
                                    </b-th>
                                </tr>
                                <tr>
                                    <template v-for="(year, index) in curYear.periods">
                                        <b-th class="text-center" width="26%" :key="index">{{
                                                year
                                            }} {{
                                                $t('modules.budget.staffing_table.file_storage.filter.year')
                                            }}
                                        </b-th>
                                    </template>
                                </tr>
                            </b-thead>
                            <b-tbody>
                                <template v-if="tabDataThree && tabDataThree.pprList">
                                    <template
                                        v-for="(pprItem, pprItemIndex) of tabDataThree.pprList">
                                        <tr class="enf-row" :key="'pprItemIndex'+pprItemIndex">
                                            <td class="bold">{{ setNulls(pprItem.ppr) }} -
                                                {{ getLocalizedName(pprItem) }}:
                                            </td>
                                            <td v-for="(year, index) in curYear.periods"
                                                :key="index">
                                                <div class="bold text-center mb-3">
                                                    {{
                                                        pprItem.years[index].value.toLocaleString()
                                                    }}
                                                    <template v-if="pprItem.years[index].value">{{
                                                            $t('modules.budget_request.calculation_forms.table_headers.units.thousand_tenge')
                                                        }}
                                                    </template>
                                                </div>
                                                <div class="exp-textarea-style"
                                                     v-bind:class="[allowable(pprItem.years[index]) ? descriptionNotEmpty : descriptionEmpty]">
                                                    <div class="box">

                                                        <span class="enf-placeholder">
                                                             {{
                                                                getPlaceholderText(pprItem.years[index])
                                                            }}
                                                        </span>
                                                        <template
                                                            v-if="isShortNote(pprItem.years[index])">
                                                            {{
                                                                getLocalizedNote(pprItem.years[index])
                                                            }}
                                                        </template>
                                                        <template v-else>
                                                            {{ shortNote(pprItem.years[index]) }}...
                                                        </template>

                                                        <template v-if="editAccess &&
                                                    pprItem.years[index].isEditable &&
                                                    pprItem.years[index].value > 0">
                                                            <i class="tas-action icon icon-pencil-edit"
                                                               @click="editDescription( true,
                                                           pprItem.years[index])"></i>
                                                        </template>
                                                        <template v-else>
                                                            <i class="tas-action icon icon-eye-open"
                                                               @click="editDescription(
                                                               pprItem.years[index].isEditable &&
                                                    pprItem.years[index].value > 0,
                                                                pprItem.years[index])"></i>
                                                        </template>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    </template>
                                </template>

                            </b-tbody>
                        </b-table-simple>
                    </div>
                </b-tab>

            </b-tabs>
        </div>
        <b-modal
            v-model="modalVisible"
            modal-class="enf-modal"
            size="lg"
            centered
            :title="modalTitle"
            hide-footer
        >
            <b-form-group>
                <template #label>{{ 'На русском:' }}</template>
                <template v-if="editAccess">
                    <b-form-textarea placeholder="введите описание"
                                     v-model="modalArea.nameRu"
                                     style="text-align: justify"></b-form-textarea>
                </template>
                <template v-else>
                    <b-form-textarea readonly v-model="modalArea.nameRu"
                                     style="text-align: justify"></b-form-textarea>
                </template>

            </b-form-group>
            <b-form-group>
                <template #label>{{ 'Қазақ тілінде:' }}</template>
                <template v-if="editAccess">
                    <b-form-textarea placeholder="сипаттаманы енгізіңіз"
                                     v-model="modalArea.nameKk"
                                     style="text-align: justify"></b-form-textarea>
                </template>
                <template v-else>
                    <b-form-textarea readonly v-model="modalArea.nameKk"
                                     style="text-align: justify"></b-form-textarea>
                </template>
            </b-form-group>
            <template v-if="editAccess">
                <b-button variant="primary" @click="addDescriptionForm">
                    {{ $t('modules.budget_execution_alteration.save') }}
                </b-button>
            </template>
            <b-button variant="light" @click="closeDescriptionForm">
                {{ $t('modules.budget_execution_alteration.cancel') }}
            </b-button>
        </b-modal>
    </div>
</template>

<script>
import ExplanatoryNoteAddTable from './ExplanatoryNoteAddTable.vue';
import CBreadCrumbs from './table-dri-breadcrumbs.vue';
import VueElementLoading from "vue-element-loading";
import {makeToast} from "@/modules/budget/bip/bip-types";
import {parseInt} from "lodash";

export default {
    name: "ExplanatoryNoteTabs",
    components: {
        'c-breadcrumbs': CBreadCrumbs,
        'loading': VueElementLoading,
        ExplanatoryNoteAddTable
    },
    props: {
        openAddTab: {
            type: Boolean,
            required: true
        },
        curPrg: {
            type: Object,
            required: true
        },
        curYear: {
            type: Object,
            required: false,
            default: () => {
            }
        },
        curRegion: {
            type: Object,
            required: true
        },
        curAbp: {
            type: Object,
            required: false,
            default: () => {
            }
        },
        curGu: {
            type: Object,
            required: false,
            default: () => {
            }
        },
        curBudgetType: {
            type: Object,
            required: false,
            default: () => {
            }
        },
        curBudgetVariant: {
            type: Object,
            required: false,
            default: () => {
            }
        },
        isGkkp: {
            type: Boolean,
            required: false
        },
        curGkkp: {
            type: Object,
            required: false,
            default: () => {
            }
        },
        editable: {
            type: Boolean,
            required: true
        },
        userId: {
            type: String,
            required: false,
            default: () => {
            }
        },
    },

    async created() {
        this.uniqueYears = this.getUniqueYears()
        await this.getTabOne();
        await this.getTabThree();
    },
    data() {
        return {
            uniqueYears: [],
            loading: false,
            editAccess: false,
            descriptionEmpty: 'text-area-block',
            descriptionNotEmpty: 'text-area-block-empty',

            modalVisible: false,
            modalTitle: '',
            modalArea: {
                nameRu: '',
                nameKk: '',
                nameEn: ''
            },
            modalItem: null,
            dataToSend: [],
            dataToSend2: [],
            needSave: false,
            saveBtnPressed: false,
            tabDataOne: null,
            tabDataThree: null,
            isFull: true,
        }
    },

    async mounted() {
        this.editAccess = await this.getRole();
    },

    methods: {
        getPlaceholderText(item) {
            const locale = this.$i18n.locale;
            let nameField;

            switch (locale) {
                case 'kk':
                    nameField = item.noteKk || item.noteRu;
                    break;
                case 'en':
                    nameField = item.noteEn || item.noteRu;
                    break;
                default:
                    nameField = item.noteRu;
                    break;
            }

            if (!nameField && item?.isEditable) {
                return this.$t('modules.explanatory_note.enter-desc'); // или просто строка, если не используешь i18n
            }

            return '';
        },
        getLocalizedName(item) {
            const locale = this.$i18n.locale
            if (!item) return '';
            switch (locale) {
                case 'kk':
                    return item.nameKk || item.nameRu
                case 'en':
                    return item.nameEn || item.nameRu
                default:
                    return item.nameRu
            }
        },
        getLocalizedNote(item) {
            const locale = this.$i18n.locale;
            if (!item) return '';
            switch (locale) {
                case 'kk':
                    return item.noteKk || item.noteRu || '';
                case 'en':
                    return item.noteEn || item.noteRu || '';
                default:
                    return item.noteRu || '';
            }
        },
        shortNote(item) {
            const note = this.getLocalizedNote(item);
            return note.slice(0, 150);
        },
        isShortNote(item) {
            const note = this.getLocalizedNote(item);
            return note.length < 150;
        },
        async getRole() {
            const accessLevel = await this.getUserAccess(this.userId);

            if (accessLevel === 1) {
                return false;
            } else if (accessLevel === 2 || accessLevel === 3) {
                if (this.editable === true) {
                    return true;
                }
            }
            return false;
        },

        async getUserAccess(userId) {
            let accessLevel = 1;
            const modules = '004.002.009';
            const url = '/api-py/user-modules/' + userId;
            const response = await fetch(url);
            const items = await response.json();
            const access = getAccess(items, modules);
            accessLevel = access.access_level

            function getAccess(items, modules) {
                const res = {};
                if (items.length > 0) {
                    for (const item of items) {
                        if (item.modules === modules) {
                            return item;
                        }
                    }
                }
                return res;
            }

            return accessLevel;
        },

        getUniqueYears() {
            const uniqueYears = new Set();
            Object.values(this.curPrg.pprItems).forEach(items => {
                items.forEach(item => {
                    if (item.year) {
                        uniqueYears.add(item.year);
                    }
                });
            });
            return uniqueYears
        },

        //ОСНОВНЫЕ СВЕДЕНИЯ
        async getTabOne() {
            const indicatorArr = [
                {
                    index: 0,
                    nameRu: 'Описание достигнутых показателей / результатов за отчетный финансовый год',
                    nameKk: 'Есепті қаржы жылындағы қол жеткізілген көрсеткіштердің / нәтижелердің сипаттамасы',
                    nameEn: 'Description of achieved indicators/results for the reporting financial year',
                    titleIndicator: 'finance_result',
                    years: []
                },
                {
                    index: 1,
                    nameRu: 'Описание текущей ситуации и имеющихся проблем',
                    nameKk: 'Ағымдағы жағдай мен бар мәселелердің сипаттамасы',
                    nameEn: 'Description of the current situation and existing problems',
                    titleIndicator: 'current_situation',
                    years: []
                },
                {
                    index: 2,
                    nameRu: 'Описание путей улучшения ситуации и решения проблем',
                    nameKk: 'Жағдайды жақсарту және мәселелерді шешу жолдарын сипаттау',
                    nameEn: 'Description of ways to improve the situation and solve problems',
                    titleIndicator: 'solve_decision',
                    years: []
                },
                {
                    index: 3,
                    nameRu: 'Описание путей достижения планируемых целевых индикаторов',
                    nameKk: 'Жоспарланған нысаналы индикаторларға қол жеткізу жолдарын сипаттау',
                    nameEn: 'Description of ways to achieve planned target indicators',
                    titleIndicator: 'target_indicator_achievement',
                    years: []
                }
            ]


            try {
                for (const year of this.curYear.periods) {

                    for (const indicator of indicatorArr) {
                        const note = {
                            id: null,
                            abp: this.curAbp.abp,
                            prg: this.curPrg.prg,
                            ppr: null,
                            gu: this.curGu.gu,
                            gkkp: this.isGkkp ? this.curGkkp.gkkp : null,
                            budgetTypeId: this.curBudgetType.budget,
                            year: year,
                            curYear: this.curYear.year,
                            region: this.curRegion.region,
                            budgetVariantId: this.curBudgetVariant.variant,
                            userId: this.userId,
                            nameKk: "",
                            nameRu: "",
                            nameEn: "",
                            titleIndicator: indicator.titleIndicator,
                            titleSorting: null,
                            updateDate: null,
                        }

                        const response = await this.getNote(note) ?? note

                        indicator.years.push({
                            index: indicator.index,
                            id: response.id ?? null,
                            nameRu: indicator.nameRu,
                            nameKk: indicator.nameKk,
                            nameEn: indicator.nameEn,
                            titleIndicator: indicator.titleIndicator,
                            noteKk: response.nameKk ?? "",
                            noteRu: response.nameRu ?? "",
                            noteEn: response.nameEn ?? "",
                            year: year,
                            isEditable: this.uniqueYears.has(year)
                        })
                    }
                }
                this.tabDataOne = indicatorArr; // Сохраняем объект

            } catch
                (error) {
                makeToast(this, 'danger', 'Ошибка загрузки Описаний на казахском и русском языках', error.toString());
            }
        },

        //РАСХОДЫ
        async getTabThree() {
            const processedData = {
                prg: this.curPrg.prg,
                nameRu: this.curPrg.nameRu,
                nameKk: this.curPrg.nameKk,
                pprList: []
            };

            try {
                for (const key in this.curPrg.pprItems) {
                    const pprData = {
                        ppr: parseInt(key),
                        nameRu: this.curPrg.pprItems[key][0].ppr.nameRu,
                        nameKk: this.curPrg.pprItems[key][0].ppr.nameKk,
                        years: []
                    };

                    for (const [index, year] of this.curYear.periods.entries()) {
                        const note = {
                            id: null,
                            abp: this.curAbp.abp,
                            prg: this.curPrg.prg,
                            ppr: key,
                            gu: this.curGu.gu,
                            gkkp: this.isGkkp ? this.curGkkp.gkkp : null,
                            budgetTypeId: this.curBudgetType.budget,
                            year: year,
                            curYear: this.curYear.year,
                            region: this.curRegion.region,
                            budgetVariantId: this.curBudgetVariant.variant,
                            userId: this.userId,
                            nameKk: "",
                            nameRu: "",
                            nameEn: "",
                            titleIndicator: "ppr",
                            titleSorting: null,
                            updateDate: null,
                        };

                        const response = await this.getNote(note) ?? note;
                        let value = 0;
                        if (this.curPrg.pprItems[key]) {
                            const foundItem = this.curPrg.pprItems[key].find(item => item.year === year);
                            if (foundItem) {
                                value = foundItem.ppr.value || 0;
                            }
                        }

                        pprData.years.push({
                            index: parseInt(key),
                            ppr: parseInt(key),
                            nameRu: this.curPrg.pprItems[key][0].ppr.nameRu,
                            nameKk: this.curPrg.pprItems[key][0].ppr.nameKk,
                            id: response.id ?? null,
                            noteKk: response.nameKk ?? "",
                            noteRu: response.nameRu ?? "",
                            titleIndicator: "ppr",
                            year: year,
                            value: value,
                            isEditable: this.uniqueYears.has(year)
                        });
                    }

                    processedData.pprList.push(pprData);
                }

                this.tabDataThree = processedData; // Сохраняем объект

            } catch (error) {
                makeToast(this, 'danger', 'Ошибка загрузки Описаний на казахском и русском языках', error.toString());
            }
        },

        async getNote(note) {
            try {
                const url = '/api/explanatory-note/get-note';
                const response = await fetch(url, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json;charset=utf-8'
                    },
                    body: JSON.stringify(note) // массив будет направлен на kotlin
                });
                if (response.ok) {
                    const text = await response.text();
                    return text ? JSON.parse(text) : null;
                } else {
                    console.error('Ошибка получения данных:', response.id);
                    this.makeToast('Предупреждение', 'Ошибка получения данных');
                }
            } catch (error) {
                console.error('Ошибка получения записей:', error);
            }
            return null
        },

        needSaved() {
            this.needSave = false;
        },

        allowable(descItem) {
            if (this.saveBtnPressed === true) {
                this.descriptionEmpty = 'text-area-block-empty';
                this.descriptionNotEmpty = 'text-area-block';
                if ((descItem.noteRu.length > 0 || descItem.noteKk.length > 0)
                    && this.editAccess && descItem.isEditable) {
                    return true;
                } else if (!descItem.isEditable) {
                    return true;
                }
                this.isFull = false;
            }
            return false;
        },

        indicatorsArr(indicatorsArr) {

            this.dataToSend2 = []
            for (const indicator of indicatorsArr) {
                for (const [index, year] of this.curYear.periods.entries()) {
                    if (indicator && indicator.hasOwnProperty(year)) {
                        if (indicator[year].nameKk === "" && indicator[year].nameRu === "") {
                            continue
                        }
                        this.dataToSend2.push({
                            abp: this.curAbp.abp,
                            prg: this.curPrg.prg,
                            gu: this.curGu.gu,
                            gkkp: this.isGkkp ? this.curGkkp.gkkp : null,
                            budgetTypeId: this.curBudgetType.budget,
                            year: year,
                            curYear: this.curYear.year,
                            region: this.curRegion.region,
                            budgetVariantId: this.curBudgetVariant.variant,
                            forecastId: indicator.forecastId,
                            programId: indicator.programId,
                            goalId: indicator.goalId,
                            indicatorId: indicator.indicatorId,
                            nameKk: indicator[year].nameKk,
                            nameRu: indicator[year].nameRu,
                            userId: this.userId
                        })

                    } else {
                        console.log(`No indicators found for year: ${year}`);
                    }
                }
            }
            this.saveIndicator();
        },

        async saveIndicator() {

            if (this.isFull === false) {
                this.makeToast('Предупреждение', 'Необходимо заполнить все обязательные поля');
            }

            if (this.dataToSend.length === 0 && this.dataToSend2.length === 0) {
                this.makeToast('Предупреждение', 'Необходимо заполнить все обязательные поля');
                return
            }
            this.loading = true;
            try {
                const url = '/api/explanatory-note/add-note';
                const response = await fetch(url, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json;charset=utf-8'
                    },
                    body: JSON.stringify(this.dataToSend)
                });

                const url2 = '/api/explanatory-note/indicator';
                const response2 = await fetch(url2, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json;charset=utf-8'
                    },
                    body: JSON.stringify(this.dataToSend2)
                });

                if ((response.status === 200) && (response2.status === 200)) {
                    this.loading = false;
                    this.makeToast('Сообщение', 'Данные сохранены', '');
                } else {
                    this.loading = false;
                    this.makeToast('Предупреждение', 'Ошибка сохранения данных');
                }
                this.dataToSend = [];
                this.dataToSend2 = [];
            } catch {
                this.loading = false;
                this.makeToast('Предупреждение', 'Ошибка сохранения данных');
            }
        },


        goBack() {
            this.$emit('moduleTabSwitches', true);
        },  //---При нажатии на кнопку "НАЗАД К СПИСКУ"

        async saveData() {
            this.needSave = true;
            this.saveBtnPressed = true;
        },


        setNulls(number) {
            const strNum = number.toString();
            return strNum.padStart(3, '0'); // Дополняем нулями до 3 символов
        },


        editDescription(show, item) {
            if (show) {
                this.modalVisible = show;
                this.modalItem = item
                this.modalTitle = this.getLocalizedName(item);
                this.modalArea = {
                    nameKk: item.noteKk,
                    nameRu: item.noteRu
                }
            }

        },

        addDescriptionForm() {
            const index = this.modalItem.index;
            this.modalItem.noteRu = this.modalArea.nameRu;
            this.modalItem.noteKk = this.modalArea.nameKk;

            this.dataToSend.push({
                abp: this.curAbp.abp,
                budgetTypeId: this.curBudgetType.budget,
                budgetVariantId: this.curBudgetVariant.variant,
                curYear: this.curYear.year,
                gkkp: this.isGkkp ? this.curGkkp.gkkp : null,
                gu: this.curGu.gu,
                id: this.modalItem.id,
                nameEn: "",
                nameKk: this.modalArea.nameKk,
                nameRu: this.modalArea.nameRu,
                ppr: this.modalItem.ppr,
                prg: this.curPrg.prg,
                region: this.curRegion.region,
                titleIndicator: this.modalItem.titleIndicator,
                titleSorting: index,
                updateDate: null,
                userId: this.userId,
                year: this.modalItem.year,
                pprSet: this.curPrg.pprSet
            })

            this.closeDescriptionForm();

        },

        closeDescriptionForm() {
            this.modalVisible = false;
        },


        makeToast(title, toastBody) {
            this.$bvToast.toast(toastBody, {
                title: title,
                autoHideDelay: 5000,
                appendToast: true
            });
        }
    }
}
</script>
